module.exports = __webpack_public_path__ + "assets/img/Employment-Inovations-Landing-Page-w720.a9bfe03e.webp";